import FormattedMessage from 'I18n/components/FormattedMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { Button } from 'foundations-components/transitional/components/Button';
import { H7 } from 'foundations-components/transitional/components/H7';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { ACTIONS, SCREENS } from '../../../constants/Tracking';
import { AppContext } from '../../../contexts/app/context';
import { AssociationModalPropsContext } from '../../../contexts/associationModal/PropsContext';
import { AssociationModalContext } from '../../../contexts/associationModal/context';
import AssociationLineItem from './AssociationLineItem/AssociationLineItem';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getInitialLine = () => ({
  quantity: 0,
  id: ''
});
function AssociationLineItems({
  property
}) {
  const {
    usageTracker,
    crmObjectType,
    hubspotUserId
  } = useContext(AssociationModalPropsContext);
  const {
    appName
  } = useContext(AppContext);
  const [lines, setLines] = useState([getInitialLine()]);
  const savedLines = useRef(lines.filter(line => line.id && line.quantity));
  const [showAddNewLineButton, setShowAddNewLineButton] = useState(false);
  const {
    currency,
    associationModalActions,
    productEntities,
    currencyExchangeRates,
    homeCurrency,
    hasMulticurrencyActive,
    dealAmountPreference
  } = useContext(AssociationModalContext);
  const isUserInteractionTracked = useRef(false);

  // need to track only first select open
  // after in amplitude we compare number of select interactions
  // and new asscoiations (line items) to created CRM object
  const trackSelectOpen = useCallback(() => {
    if (!isUserInteractionTracked.current) {
      usageTracker.trackInteraction(Object.assign({
        screen: SCREENS.associations,
        type: crmObjectType
      }, ACTIONS.associations.clickLineItemsSelect));
      isUserInteractionTracked.current = true;
    }
  }, [crmObjectType, usageTracker]);
  const onLineItemChange = ({
    line,
    index
  }) => {
    lines.splice(index, 1, line);
    setLines(lines.slice());
  };
  const onQuantityChange = ({
    quantity,
    index
  }) => {
    const lineToUpdate = Object.assign({}, lines[index]);
    lineToUpdate.quantity = quantity;
    lines.splice(index, 1, lineToUpdate);
    setLines(lines.slice());
  };
  const addNewLineItemHandler = () => {
    setLines([...lines, getInitialLine()]);
  };
  const deleteLine = index => {
    if (lines.length > 1) {
      setLines(lines.filter((_line, i) => i !== index));
    } else {
      associationModalActions.resetNewLineItems();
      setLines([getInitialLine()]);
    }
  };
  useEffect(() => {
    setShowAddNewLineButton(lines.every(line => !!line.id));
    const lineToCalculate = lines.filter(line => line.id && line.quantity);
    if (lineToCalculate.length && (savedLines.current.some((line, index) => lineToCalculate[index] !== line) || savedLines.current.length !== lineToCalculate.length)) {
      associationModalActions.calculateProperties({
        lines: lineToCalculate.map(line => ({
          quantity: line.quantity,
          product: productEntities[line.id]
        })),
        currency,
        currencyExchangeRates,
        homeCurrency,
        hasMulticurrencyActive,
        userId: hubspotUserId,
        dealAmountPreference,
        appName
      });
      savedLines.current = lineToCalculate;
    }
  }, [lines, associationModalActions, currency, currencyExchangeRates, homeCurrency, hasMulticurrencyActive, hubspotUserId, dealAmountPreference, productEntities, appName]);
  useEffect(() => {
    setLines([getInitialLine()]);
  }, [currency]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(TFlex, {
      marginBlockStart: "400",
      children: [/*#__PURE__*/_jsx(Box, {
        grow: 2,
        marginInlineEnd: "400",
        children: /*#__PURE__*/_jsx(H7, {
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "associationsPanel.tabs.create.associationProperties.lineTitle",
            options: {
              crmObjectType: (property.definition.toObjectType || '').split('_').join(' ').toLowerCase()
            }
          })
        })
      }), /*#__PURE__*/_jsx(Box, {
        grow: 0,
        basis: 65,
        marginInlineEnd: "500",
        children: /*#__PURE__*/_jsx(H7, {
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "associationsPanel.tabs.create.associationProperties.quantity"
          })
        })
      })]
    }), lines.map((line, i) => /*#__PURE__*/_jsx(AssociationLineItem, {
      line: line,
      property: property,
      index: i,
      onLineItemChange: onLineItemChange,
      onQuantityChange: onQuantityChange,
      deleteLine: deleteLine,
      trackSelectOpen: trackSelectOpen
    }, i)), showAddNewLineButton ? /*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: addNewLineItemHandler,
      marginBlockStart: "100",
      children: /*#__PURE__*/_jsxs(TFlex, {
        alignSelf: "start",
        align: "center",
        gap: 4,
        children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "associationsPanel.tabs.create.associationProperties.addNewLineItem"
        })]
      })
    }) : null]
  });
}
export default AssociationLineItems;